import {
  CardData,
  CardRewardsEarnRate,
  AdvancedCategory,
  SelectableCategoriesEarnRate,
} from './CardData';

// Helper type guards for working with the disjoint union
export const isSelectableCategoriesEarnRate = (
  earnRate: CardRewardsEarnRate
): earnRate is SelectableCategoriesEarnRate => {
  return earnRate.category === 'selectable_categories';
};

export const isQuarterlyCategoriesEarnRate = (
  earnRate: CardRewardsEarnRate
): earnRate is SelectableCategoriesEarnRate => {
  return earnRate.category === 'quarterly_categories';
};

export const isFixedCategoryGroupEarnRate = (
  earnRate: CardRewardsEarnRate
): earnRate is SelectableCategoriesEarnRate => {
  return earnRate.category === 'fixed_category_group';
};

export const isStandardEarnRate = (
  earnRate: CardRewardsEarnRate
): earnRate is SelectableCategoriesEarnRate => {
  return (
    earnRate.category !== 'selectable_categories' &&
    earnRate.category !== 'quarterly_categories' &&
    earnRate.category !== 'fixed_category_group'
  );
};

export const isAdvancedCategory = (
  category: string | AdvancedCategory
): category is AdvancedCategory => {
  return typeof category === 'object' && 'category_description' in category;
};

// Helper to get all selectable categories from a card
export const getSelectableCategories = (card: CardData): string[] => {
  const selectableRates = card.rewards_earn_rates.filter(
    isSelectableCategoriesEarnRate
  );
  const allCategories: string[] = [];

  selectableRates.forEach((rate) => {
    allCategories.push(
      ...rate.selectableCategories.categories.map((cat) =>
        typeof cat === 'string' ? cat : cat.category_description
      )
    );
  });

  return Array.from(new Set(allCategories)); // Remove duplicates
};

// Helper to check if a card has quarterly rotation
export const hasQuarterlyRotation = (card: CardData): boolean => {
  return card.rewards_earn_rates.some(
    (rate) =>
      isSelectableCategoriesEarnRate(rate) &&
      rate.selectableCategories.categoryRotationFrequency === 'quarterly'
  );
};

// Helper to check if a card requires user selection
export const requiresUserSelection = (card: CardData): boolean => {
  return card.rewards_earn_rates.some(
    (rate) =>
      isSelectableCategoriesEarnRate(rate) &&
      rate.selectableCategories.requireUserSelection
  );
};
